import { useBreadcrumbs } from '@/hooks/Breadcrumbs/useBreadcrumbs';
import { cn } from '@/lib/utils';
import resourceUrl from '@/util/makeUrl';
import Link from 'next/link';
import { Fragment, useMemo } from 'react';
import classes from './breadcrumbs.module.css';

const Breadcrumbs = ({
  categoryId,
  currentProduct,
  className,
  breadcrumbsData,
}: {
  categoryId: string;
  currentProduct?: string;
  className?: string;
  breadcrumbsData?: any;
}) => {
  const talonProps = useBreadcrumbs({
    breadcrumbsData,
  });

  const { currentCategory, currentCategoryPath, normalizedData, handleClick } = talonProps;

  // For all links generate a fragment like "/ Text"
  const links = useMemo(() => {
    return normalizedData.map(({ text, path }) => {
      return (
        <Fragment key={text}>
          <Link
            className={cn('capitalize', 'font-roboto-light font-light text-black', 'relative', classes.homeLink)}
            href={resourceUrl(path)}
            onClick={handleClick}
          >
            {text}
          </Link>
          <span className={cn('capitalize', 'font-roboto-light font-light text-black', 'relative', classes.homeLink)}>
            &nbsp;&gt;&nbsp;
          </span>
        </Fragment>
      );
    });
  }, [handleClick, normalizedData]);

  const currentCategoryLink = currentProduct ? (
    normalizedData.length === 0 ? (
      <>
        <Link
          className={cn('capitalize', 'font-roboto-light font-light text-black', 'relative', classes.homeLink)}
          href={resourceUrl(currentCategoryPath)}
          onClick={handleClick}
        >
          {currentCategory}
        </Link>
        <span className={cn('capitalize', 'font-roboto-light font-light text-black', 'relative', classes.homeLink)}>
          &nbsp;&gt;&nbsp;
        </span>
      </>
    ) : null
  ) : (
    <span className={cn('capitalize', 'font-roboto-light font-light text-black', classes.homeLink)}>
      {currentCategory}
    </span>
  );

  const currentProductNode = currentProduct ? (
    <Fragment>
      <span
        className={cn(
          'capitalize',
          'pr-3',
          'font-roboto-light font-light text-black',
          classes.homeLink,
          'relative',
          'mr-2.5',
        )}
      >
        {currentProduct}
      </span>
    </Fragment>
  ) : null;

  return (
    <div
      className={cn(
        'overflow-hidden',
        'text-ellipsis',
        'pt-2.5',
        'pb-[40px]',
        'sm_pb-[20px]',
        'container mx-auto',
        'text-sm',
        'whitespace-nowrap',
        className,
        classes.breadcrumbsBox,
      )}
      aria-live='polite'
      aria-busy='false'
    >
      <>
        <Link
          className={cn(
            'font-roboto-medium font-medium capitalize text-black',
            'relative',
            'underline',
            classes.homeLink,
          )}
          href='/'
        >
          Home
        </Link>
        <span className={cn('capitalize', 'font-roboto-light text-[16px] font-light text-black', 'relative')}>
          &nbsp;&gt;&nbsp;
        </span>
      </>
      {links}
      <span>{currentCategoryLink}</span>
      {currentProductNode}
    </div>
  );
};

export default Breadcrumbs;
